import { PostReframeInferencesApiArg } from "infra/api/generated/api";

export const REFRAME_LOCATION_LABELS: Record<
  NonNullable<PostReframeInferencesApiArg["body"]["inputLocation"]>,
  string
> = {
  top: "Top",
  bottom: "Bottom",
  left: "Left",
  right: "Right",
  middle: "Middle",
};
